module.exports = __webpack_public_path__ + "img/share-capital.e1897566.png";